import React from 'react'
import { LoadingLine } from 'components/Layout/LoadingLine'

import { TOP_BAR_HEIGHT } from './TopBarRight'

export const TopBarRightLoading = () => (
  <div
    className="l-topbar-right flexbox width-full flexbox-align-center zindex-large background-shade-100 border-bottom-medium border-shade-50"
    style={{ height: TOP_BAR_HEIGHT }}
  >
    <div className="flexbox flexbox-grow flexbox-align-center margin-left-medium">
      <div className="width-full">
        <LoadingLine lineWidth="30%" marginBottom={0} />
      </div>
    </div>
  </div>
)
